<template>
  <div :class="[vertical ? 'tab__vertical' : '',
                !vertical ? 'tab__horizontal' : '']">
    <div class="tab__nav">
      <ul>
        <li class="tab__nav__item" v-for="tab in tabs" :key="tab.name" :class="{ 'tab__nav__item--active': tab.isActive }">
          <p4a-button v-if="vertical"
                      :fixedWH="ifVertical"
                      :showIcon="true"
                      :onlyIconVisible="ifVertical"
                      :icon="tab.icon"
                      :text="tab.name"
                      :product="'ds'"
                      :disable="false"
                      @click="selectTab(tab)">
          </p4a-button>
          <div class="tab__horizontal__button" v-else @click="selectTab(tab)">
            <p4a-icon :icon="tab.icon"></p4a-icon>
            {{ tab.name }}
          </div>
        </li>
      </ul>
    </div>
    <div class="tab__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    vertical: Boolean
  },
  data () {
    return {
      tabs: []
    }
  },
  computed: {
    ifVertical () {
      return this.vertical === true
    }
  },
  created () {
    this.$on('tabs', value => {
      this.tabs.push(value)
    })
  },
  methods: {
    selectTab (selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = (tab.name === selectedTab.name)
      })
      this.$emit('tabSelected', selectedTab.name)
    }
  }
}
</script>

<style lang="scss" scoped>
.tab {

  &__nav {
    width: 100%;
    border-bottom: 1px solid #ddd;

    &__item {
      color: #afafaf;
      position: relative;
      display: inline-block;

      &--active { color: #00bbd5; }
    }
  }

  &__vertical {

    .tab__nav {
      width: 50px;
      top: 0;
      right: 0;
      bottom: 0;
      position: absolute;
      border-bottom: none;
      border-left: 1px solid #ddd;
    }

    .tab__content {
      width: calc(100% - 50px);
      display: inline-block;
    }
  }

  &__horizontal {

    &__button {
      width: auto;
      height: 50px;
      font-size: 12px;
      padding: 7px 10px;
      text-align: center;
      position: relative;

      .p4a-icon {
        width: 100%;
        display: block;
        font-size: 18px;
      }

      &:hover {
        cursor: pointer;
        background-color: #f7f7f7;
      }
    }

    .tab__nav__item--active {

      &:after {
        width: 100%;
        height: 3px;
        bottom: 0;
        content: '';
        position: absolute;
        background-color: #00bbd5;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tab/tabs.vue